import { useState, useEffect, useCallback } from 'react';
import { billingService, type SubscriptionStatus } from '../services/api';

export function useSubscription() {
  const [sub, setSub] = useState<SubscriptionStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetch = async () => {
      try {
        const res = await billingService.getSubscription();
        if (!cancelled) setSub(res.data);
      } catch {
        if (!cancelled) setSub(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetch();
    return () => { cancelled = true; };
  }, []);

  const isPro = sub?.isPro ?? false;

  const requirePro = useCallback((): boolean => {
    if (!isPro) {
      window.location.href = '/pricing';
      return false;
    }
    return true;
  }, [isPro]);

  return { sub, loading, isPro, requirePro };
}
